import {useNavigate} from "react-router-dom";
import {Button, Form, Image, Input, Toast} from "antd-mobile";
import {userLogin} from "../../common/ApiAction";
import {TOASTDURATION} from "../../common/Utils";

const AzamPayLogin = () => {
    const navigate = useNavigate()

    const onFinish = (values: any) => {
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        userLogin(values).then((res: any) => {
            Toast.clear();
            if (!res.executed) {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            } else {
                navigate('/azampay/orders', {state: {mobile: values.mobile}})
            }
        }).catch(err => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err.message, duration: TOASTDURATION})
        })
    }

    return <div style={{backgroundColor: '#F5F6FA', height: '100vh', display: "flex", flexDirection: "column", padding: '0 12px', justifyContent: "center", textAlign: "center"}}>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 25}}>
            <Image src={require('../../assets/icon_ego_logo.jpg')}/>
        </div>
        <Form
            onFinish={onFinish}
            mode={'card'}
            layout='horizontal'
            footer={<Button shape='rounded' block type='submit' color='primary' size='middle'>Login</Button>}>
            <Form.Header>AzamPay Login</Form.Header>
            <Form.Item name='mobile' rules={[{ required: true, message: 'Please enter your mobile number' }]}>
                <Input type={"number"} placeholder={"Mobile Number"} />
            </Form.Item>
            <Form.Item name='password' rules={[{ required: true, message: 'Please enter your password' }]}>
                <Input placeholder={"Password"} />
            </Form.Item>
        </Form>
    </div>
}
export default AzamPayLogin